import Nullstack from 'nullstack';
export default function IconTruckReturn({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-truck-return",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "17",
    x2: "15",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M13 6h5l3 5v6h-2"
  }), " ");
}